<template>
<footer class="footer">
  <div class="container">
    <div class="row">
      <ul>
        <li v-if="HEADER_LANG === 'en'"><a href="#sectionScroll2">About Us</a></li>
        <li v-if="HEADER_LANG === 'ru'"><a href="#sectionScroll2">О нас</a></li>
        <li v-if="HEADER_LANG === 'en'"><a href="#sectionScroll3">PROJECTS</a></li>
        <li v-if="HEADER_LANG === 'ru'"><a href="#sectionScroll3">Проекты</a></li>
        <li v-if="HEADER_LANG === 'en'"><a href="#sectionScroll4">CONTACT</a></li>
        <li v-if="HEADER_LANG === 'ru'"><a href="#sectionScroll4">Контакты</a></li>
      </ul>
    </div>
  </div>
</footer>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "AppFooter",
  computed: {
    ...mapGetters([
      'HEADER_LANG',
    ])
  }
}
</script>

<style scoped lang="scss">
$cRed: #EF3527;
$cBlack: #252525;
$cYellow: #FFA630;
$cWhite: #FFFFFF;
$cGrey: rgba(55, 57, 46, .5);

.footer {
  border-top: 1px solid $cGrey;
  background-color: $cBlack;
  color: #fff;
  padding: 80px 0;
  @media (max-width: 997.98px) {
    padding: 60px 0;
  }
  @media (max-width: 575.98px) {
    padding: 30px 0;
  }
  .row {
    display: flex;
    ul {
      display: flex;
      li {
        margin-right: 30px;
        &:last-child {
          margin-right: 0;
        }
      }
      a {
        font-size: 1.4rem;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        text-transform: uppercase;
        transition: .1s linear all;
        text-decoration: underline transparent;
        &:hover {
          color: $cRed;
          text-decoration: underline $cRed;
        }
        &:active {
          opacity: .6;
        }
      }
    }
  }
}
</style>
